import { useNavigate, useParams } from "react-router-dom";
import AuiIcon from "../../../components/AuiDropdown/AuiIcon";
import Headings from "../../../components/Headings/Headings";
import "./OrganizationView.scss";
import {
  fetchOrganizationAdmins,
  fetchOrganizationById,
} from "../../../services/organization.service";
import { useEffect, useState } from "react";
import AuiButton from "../../../components/Buttons/Buttons";

const OrganizationsView = () => {
  const { id } = useParams<{ id: string }>();
  const [organizationData, setOrganizationData] = useState<any>(null);
  const [adminData, setAdminData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  
  const handleBackButton = () => {
    navigate("/organization-listing");
  };

  const handleNotFound = () => {
    navigate("/page-not-found");
  };
  const viewOrganizationById = async (OrganizationId: number) => {
    if (!OrganizationId || OrganizationId === -1) {
      return;
    }
    setIsLoading(true);
    const fetchOrganizationDetail = await fetchOrganizationById(OrganizationId);
    if (fetchOrganizationDetail?.error?.status === 404) {
      handleNotFound();
      return
    }
    setOrganizationData(fetchOrganizationDetail);
    setIsLoading(false);
  };

  const viewAdminDetailByCode = async () => {
    if (!organizationData?.code) {
      return;
    }
    setIsLoading(true);
    const fetchAdminDetail = await fetchOrganizationAdmins(
      organizationData?.code
    );
    setAdminData(fetchAdminDetail);
    setIsLoading(false);
  };

  const isValidId = (id: string | undefined) => {
    return id !== undefined && /^\d+$/.test(id);
  };

  useEffect(() => {
    if (!isValidId(id)) {
      handleNotFound();
      return;
    }
    const OrganizationId = parseInt(id ?? "", 10);
    viewOrganizationById(OrganizationId);
  }, [id]);

  useEffect(() => {
    if (organizationData?.code) {
      viewAdminDetailByCode();
    }
  }, [organizationData]);

  return (
    <div className="container mt-4 mb-5 organizationViewCont">
       {isLoading ? (
        <div className="aui-loader loaderHeight" data-testid="loading-indicator">
          <aui-loader type="content"></aui-loader>
        </div>
      ) : (
        <>
      <aui-breadcrumb
        previouspages='[{"title":"All Organizations","url":"/organization-listing"}]'
        currentpage={organizationData?.name}
      ></aui-breadcrumb>
      <Headings size="h1" className="pb-2 my-2 border-bottom">
        {organizationData?.name}
      </Headings>
          <div className="border-bottom my-3 orgDetailsSec">
            <div className="row mb-0 mb-lg-4">
              <div className="col-12 col-md-6 col-lg-4 mb-3">
                <label htmlFor="type">Organization Type</label>
                <p>{organizationData?.type.charAt(0).toUpperCase() + organizationData?.type.slice(1).toLowerCase()}</p>
              </div>
              <div className="col-12 col-md-6 col-lg-4 mb-3">
                <label htmlFor="name">Organization Name</label>
                <p>{organizationData?.name}</p>
              </div>
              <div className="col-12 col-md-12 col-lg-4 mb-3">
                <label htmlFor="contactDetails">Street Address</label>
                <p>{organizationData?.contactDetails}</p>
              </div>
            </div>
            <div className="row mb-0 mb-lg-4">
              <div className="col-12 col-md-6 col-lg-4 mb-3">
                <label htmlFor="countryName">Country</label>
                <p>{organizationData?.organisationGeographies?.countryName}</p>
              </div>
              <div className="col-12 col-md-6 col-lg-4 mb-3">
                <label htmlFor="regionName">Region</label>
                <p>{organizationData?.organisationGeographies?.regionName}</p>
              </div>
              <div className="col-12 col-md-6 col-lg-4 mb-3">
                <label htmlFor="stateName">State</label>
                <p>{organizationData?.organisationGeographies?.stateName}</p>
              </div>
            </div>
          </div>
          {organizationData?.type === "SPONSORING" && (
            <div className="row mb-0 mb-lg-4 orgDetailsSec">
              <div className="col-12 col-md-6 col-lg-4 mb-3">
                <label htmlFor="type">Certifying Organization</label>
                <p>{organizationData?.approvingOrgName.charAt(0).toUpperCase() + organizationData?.approvingOrgName.slice(1).toLowerCase() || ""}</p>
              </div>
            </div>
          )}
          {adminData?.length > 0 && (
            <div className="adminTableSection p-3">
              <Headings
                size="h2"
                defaultClass="h8"
                className="blue mb-2"
                id="orgAdminTable"
              >
                <AuiIcon
                  iconClass="avataroutline"
                  svgwidth="20"
                  svgheight="20"
                ></AuiIcon>
                <span className="ml-1 tableTitle">Admins ({adminData?.length})</span>
              </Headings>
              <div className="mt-2 mt-lg-4">
                <aui-table
                  type="default"
                  headerbackground={true}
                  headerborder={true}
                >
                  <table>
                    <thead>
                      <tr>
                        <th scope="col">
                          <div className="aui-th font-600">First Name</div>
                        </th>
                        <th scope="col">
                          <div className="aui-th font-600">Last Name</div>
                        </th>
                        <th scope="col">
                          <div className="aui-th font-600">Email</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {adminData?.map((admin: any, index: number) => (
                        <tr key={admin?.id || index}>
                          <td data-title="First Name">
                            <div className="aui-td">{admin?.firstName}</div>
                          </td>
                          <td data-title="Last Name">
                            <div className="aui-td">{admin?.lastName}</div>
                          </td>
                          <td data-title="Email">
                            <div className="aui-td">{admin?.email}</div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </aui-table>
              </div>
            </div>
          )}
        </>
      )}
      <div className="my-3 my-lg-4">
        <span className="backButton">
          <AuiIcon iconClass="arrowleft" svgwidth="21" svgheight="21"/>
          <AuiButton
            variant="general-text-link"
            buttontitle="Back"
            buttonid=""
            modalid="exampleModal"
            size="large"
            anchorlinkurl=""
            buttonclass="customClasstest"
            buttonClick={handleBackButton}
            data-testid="back-button"
          ></AuiButton>
        </span>
      </div>
    </div>
  );
};

export default OrganizationsView;
